import React, { useState } from 'react';
import Sidebar from '../shared/Sidebar';
import Header from '../shared/Header';
import ImpersonationBanner from './ImpersonationBanner';
import OnboardingBlurWrapper from './OnboardingBlurWrapper';
import { ProductTourProvider } from '../../contexts/ProductTourContext';
import ProductTourCard from '../tour/ProductTourCard';
import TrialCountdownWidget from '../trial/TrialCountdownWidget';
import TrialExpiryOverlay from '../trial/TrialExpiryOverlay';
import { useGetVendorMeQuery } from '../../store/vendorApi';

const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { data: vendor } = useGetVendorMeQuery();

  const isTrial = vendor?.status === 'trial';
  const isTrialExpired = vendor?.status === 'trial_expired';
  const [activationRequested, setActivationRequested] = useState(vendor?.activationRequested ?? false);

  return (
    <ProductTourProvider>
      <div className="min-h-screen bg-gray-50">
        <ImpersonationBanner />
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <div className="main-content">
          <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

          <main className="p-6">
            <OnboardingBlurWrapper />
          </main>
        </div>
      </div>
      <ProductTourCard />

      {isTrial && vendor.trialEndDate && (
        <TrialCountdownWidget
          trialEndDate={vendor.trialEndDate}
          activationRequested={activationRequested || !!vendor.activationRequested}
          vendorEmail={vendor.email}
        />
      )}

      {isTrialExpired && (
        <TrialExpiryOverlay
          activationRequested={activationRequested || !!vendor?.activationRequested}
          vendorEmail={vendor?.email ?? ''}
          onActivationRequested={() => setActivationRequested(true)}
        />
      )}
    </ProductTourProvider>
  );
};

export default Layout;